export default __webpack_public_path__ + "static/media/36k.05950294.md";